import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const StaticRedirect = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Ottieni il path completo incluso /api/static
    const fullPath = location.pathname;
    
    // Costruisci l'URL del backend
    const backendUrl = `https://api-ecard.bildastudio.com${fullPath}`;
    
    // Fai il redirect immediato
    window.location.replace(backendUrl);
  }, [location.pathname]);
  
  // Mostra un messaggio di caricamento mentre avviene il redirect
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px'
    }}>
      <p>Caricamento in corso...</p>
    </div>
  );
};

export default StaticRedirect;